//  Keys correspond to keys in stepData.step3 in store
import React, {useContext, useEffect, useRef} from "react";
import {ReactReduxContext, useSelector} from "react-redux";
import {ERROR_LIST, RADIO_ERROR_ID} from "../steps";

/**
 * Represents an error panel component.
 * @returns {React.Component} - The error panel component.
 */
export function ErrorPanel() {
    const context = useContext(ReactReduxContext);
    const error = () => context.store.getState().app.errors.step3;
    const errorMap = useSelector(error);

    const errorPanelRef = useRef(null);

    useEffect(() => {
        if (Object.keys(errorMap).length > 0 && errorPanelRef.current) {
            errorPanelRef.current.focus();
        }
    }, [errorMap]);

    if (Object.keys(errorMap).length === 0) {
        return null;
    }

    return (
        <div
            id="Step3ErrorPanel"
            ref={errorPanelRef}
            tabIndex="-1"
            className='section-3-error-text'
        >
            {Object.keys(errorMap).length > 0 && (
                <>
                    <p>Before proceeding to the next step you’ll need to select:</p>
                    <ul>
                        {Object.keys(errorMap).map(key => {
                            const id = RADIO_ERROR_ID[key] || key;
                            return (
                                <li key={key} style={{listStyleType: "disc"}}>
                                    {errorMap[key]}
                                    <a href={`./#${id}`}>
                                        <span className="sr-only">{`Jump to ${ERROR_LIST[key].label}`}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}
        </div>
    );
}